import styled from 'styled-components';

const DownloadLink = styled.a`
  outline: none;
  text-decoration: None;
  padding: 2px 1px 0;
  display: inline;
  color: blue;
  font-size: .9rem;
  :visited {
    color: blue;
  }
  :hover {
    cursor: pointer;
  }
  :active {
    color: red;
  }
`;

export default {
  DownloadLink,
};
